export const localStorageKeys = {
  language: 'language',
  knownHostKeyFingerprints: 'known_host_key_fingerprints',
  authKeySets: 'auth_key_sets',
};
